export function resetOAuthRequirements() {
  return {
    type: "RESET_OATH_REQUIREMENTS"
  };
}


export function resetNotificationError() {
  return {
    type: "RESET_NOTIFICATION_ERROR"
  };
}


export function setCurrentStep() {
  return {
    type: "SET_CURRENT_STEP"
  };
}


export function setPreviousStep() {
  return {
    type: "SET_PREVIOUS_STEP"
  };
}
